import { z } from 'zod';
// Shape do Json Empresa.configuracoes:
// { politicaSemCerca: 'pendente'|'validar', comprovanteAutomatico: boolean, toleranciaAtrasoMin: number }
export const UpdateEmpresaConfigSchema = z.object({
    // politica quando o funcionario nao tem nenhuma cerca resolvida
    politicaSemCerca: z.enum(['pendente', 'validar']).optional(),
    comprovanteAutomatico: z.boolean().optional(),
    toleranciaAtrasoMin: z.number().int().min(0).max(120).optional(),
});
//# sourceMappingURL=empresa.js.map